import { useEffect, useMemo, useState } from 'react'

import { MasterLoadingKeys } from '~/hooks/useUi'

import * as S from './styles'
import { Spinner } from '@vtex/shoreline'

type MasterLoadingProps = {
  messages: MasterLoadingKeys[]
}

const MasterLoading = ({ messages = [] }: MasterLoadingProps) => {
  const [showComponent, setShowComponent] = useState(false)

  const isActive = useMemo(() => !!messages?.length, [messages])

  useEffect(() => {
    if (isActive && !showComponent) return setShowComponent(true)

    if (!isActive && showComponent)
      setTimeout(() => {
        setShowComponent(false)
      }, 1000)
  }, [isActive, showComponent])

  return showComponent ? (
    <S.Container isActive={isActive}>
      <Spinner size={32} style={{marginBottom: '16px'}} />

      <div className="messages">
        {messages.map(item => (
          <div key={item.id}>{item.message}</div>
        ))}
      </div>
    </S.Container>
  ) : (
    <></>
  )
}

export default MasterLoading
